import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-button',
  standalone: true,
  imports: [
    CommonModule
  ],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
  encapsulation: ViewEncapsulation.ShadowDom
})
export class ButtonComponent {
  @Input() iconSrc: string = '';
  @Input() buttonType: string = 'button';
  @Input() buttonText: string = '';
  @Input() disabled: boolean = false;
  @Input() type: 'primary' | 'secondary' |'secondary-noborder'|  'reset' = 'primary';
  @Output() onClick = new EventEmitter<Event>();


  handleClick(event: any) {
    this.onClick.emit(event);
  }
}
